import { TeamText } from "i18n/about";
import {
  ClientandPartnerButton,
  ClientandPartnerText,
  ClientDirectoryData,
} from "i18n/client";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Team = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = TeamText[lang];
  const btn = ClientandPartnerButton[lang];

  const navigate = useNavigate();

  const directory = ClientDirectoryData[lang];

  const [selectedCategory, setSelectedCategory] = useState(
    directory.categories[0],
  );

  const filteredClients =
    selectedCategory === directory.categories[0]
      ? directory.clients
      : directory.clients.filter((c) => c.category === selectedCategory);

  return (
    <section className=" mx-auto py-12 bg-[#f5f5f3]">
      <div className="max-w-6xl mx-auto text-[#111] px-0 ">
        <div className="text-center my-14">
          <h2 className="font-[Crimson] text-4xl md:text-5xl text-reddark">
            {t.title}
          </h2>
          <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />
        </div>

        {/* Intro */}
        <div className="space-y-8 text-base md:text-lg leading-relaxed pb-8 px-6">
          {t.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
